import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { getPaymentServiceBase } from "../lib/paymentApiUrl";

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const orderId = (searchParams.get("order") || "").trim();
  const [eventId, setEventId] = useState("");

  useEffect(() => {
    if (!orderId) return undefined;

    let cancelled = false;
    const cancelOrder = async () => {
      try {
        const response = await fetch(`${getPaymentServiceBase()}/cancel-checkout`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ payment_order_id: orderId }),
        });
        const result = await response.json();
        if (!cancelled && result.event_id) {
          setEventId(result.event_id);
        }
      } catch (error) {
        console.error("Unable to mark checkout cancelled:", error);
      }
    };

    cancelOrder();
    return () => {
      cancelled = true;
    };
  }, [orderId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] px-6 text-white">
      <div className="w-full max-w-md bg-[#161616] p-10 rounded-3xl border border-white/10 text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 bg-red-500/10 text-red-400">
          <AlertCircle size={40} />
        </div>
        <p className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-2">PayMongo</p>
        <h1 className="text-2xl font-black mb-4 tracking-tight">Payment cancelled</h1>
        <p className="text-sm text-white/70 mb-8">
          No tickets were issued. You can return to the event and try checkout again.
        </p>
        <div className="flex flex-col gap-3">
          {eventId ? (
            <Link
              to={`/event/${eventId}`}
              className="w-full bg-white text-black py-3 rounded-full text-xs font-black uppercase tracking-widest"
            >
              Back to event
            </Link>
          ) : (
            <Link
              to="/events"
              className="w-full bg-white text-black py-3 rounded-full text-xs font-black uppercase tracking-widest"
            >
              Browse events
            </Link>
          )}
          <Link
            to="/tickets"
            className="w-full border border-white/20 py-3 rounded-full text-xs font-black uppercase tracking-widest"
          >
            View my tickets
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
